import { render, staticRenderFns } from "./DatepickerModal.vue?vue&type=template&id=32c567f8"
import script from "./DatepickerModal.vue?vue&type=script&lang=ts"
export * from "./DatepickerModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports